import { useTranslation } from 'react-i18next'

import FeedbackModal from '@features/feedback/ui/modal'
import styles from '@features/feedback/ui/modal/styles.module.scss'
import { useModalStore } from '@features/modal'

import { useJivoSite } from '@shared/hooks/useJivoSite'




export default function useFeedbackModal () {
  const { openModal, closeModal } = useModalStore()
  const { openJivoChat, isReady } = useJivoSite()
  const { t: tc } = useTranslation('common')

  const openFeedbackModal = () => {
    if (isReady && openJivoChat()) {
      return
    }
    
    openModal('feedback', <FeedbackModal />, {
      title: tc('feedback.title'),
      description: tc('feedback.desc'),
      classes: {
        content: styles['modal-content'],
      },
    })
  }

  const closeFeedbackModal = () => {
    closeModal('feedback')
  }

  return {
    openFeedbackModal,
    closeFeedbackModal,
  }
}
